import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { MdDragIndicator } from "react-icons/md";
import VendorInvoiceChat from "./VendorInvoiceChat";

/**
 * Horizontal split: left content (payables / status) + resizable agent chat.
 */
const VendorInvoiceReviewSplit = ({
    autoSaveId = "vendor-invoice-review",
    left,
    chatProps,
    style,
    chatDefaultSize = 38,
    chatMinSize = 25,
}) => (
    <div style={{
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        height: "100%",
        ...style,
    }}>
        <PanelGroup
            autoSaveId={autoSaveId}
            direction="horizontal"
            style={{ flex: 1, minHeight: 0, height: "100%" }}
        >
            <Panel
                defaultSize={100 - chatDefaultSize}
                minSize={35}
                style={{
                    minWidth: 0,
                    overflow: "auto",
                    paddingRight: "0.5rem",
                }}
            >
                {left}
            </Panel>
            <PanelResizeHandle className="resize-handle" style={{ height: "100%" }}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                }}>
                    <MdDragIndicator size="1.2rem" />
                </div>
            </PanelResizeHandle>
            <Panel
                defaultSize={chatDefaultSize}
                minSize={chatMinSize}
                style={{
                    minWidth: 0,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    paddingLeft: "0.5rem",
                }}
            >
                <VendorInvoiceChat fill {...chatProps} />
            </Panel>
        </PanelGroup>
    </div>
);

export default VendorInvoiceReviewSplit;
